import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-content" }
const _hoisted_3 = { class: "footer-content" }

import { ElRow, ElCol, ElLink, ElImage } from 'element-plus';
import imagedata from '../assets/gonan.png';

export default /*@__PURE__*/_defineComponent({
  __name: 'FootCom',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElRow), { justify: "center" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElCol), {
          xs: 24,
          sm: 8,
          md: 6
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "footer-content" }, [
              _createElementVNode("h3", null, "版权所有"),
              _createElementVNode("p", null, "青岛上赛云软件有限公司")
            ], -1)
          ])),
          _: 1,
          __: [0]
        }),
        _createVNode(_unref(ElCol), {
          xs: 24,
          sm: 8,
          md: 6
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("h3", null, "备案号", -1)),
              _createElementVNode("p", null, [
                _createVNode(_unref(ElLink), {
                  href: "https://beian.miit.gov.cn",
                  traget: "_blank",
                  underline: "never"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("鲁ICP备2023052212号")
                  ])),
                  _: 1,
                  __: [1]
                })
              ]),
              _createElementVNode("p", null, [
                _createVNode(_unref(ElImage), {
                  class: "thumbimg",
                  fit: "fill",
                  src: _unref(imagedata)
                }, null, 8, ["src"]),
                _createVNode(_unref(ElLink), {
                  href: "https://beian.mps.gov.cn/#/query/webSearch?code =37020202370292",
                  rel: "noreferrer",
                  traget: "_blank",
                  underline: "never"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("鲁公网安备37020202370292")
                  ])),
                  _: 1,
                  __: [2]
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElCol), {
          xs: 24,
          sm: 8,
          md: 6
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("h3", null, "隐私", -1)),
              _createElementVNode("p", null, [
                _createVNode(_unref(ElLink), {
                  title: "查看隐私保护声明",
                  href: "/privacystatement",
                  underline: "never"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("span", null, "隐私保护声明", -1)
                  ])),
                  _: 1,
                  __: [4]
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})